<template lang="html">
  <div class="dashboard">
    <v-header :name="name"></v-header>
    <div class="container">
      <div class="left">
        <div class="item">
          <v-bar></v-bar>
        </div>
        <div class="item">
          <v-line></v-line>
        </div>
        <div class="item">
          <v-table></v-table>
        </div>
      </div>
      <div class="center">
        <v-center :positionTimes="positionTimes"></v-center>
      </div>
      <!-- <div class="right">
        <v-detail :positionTimes="positionTimes"></v-detail>
      </div> -->
    </div>
  </div>
</template>

<script>
import bar from 'components/recordInformation/bar'
import header from 'components/common/header'
import line from 'components/recordInformation/line'
import center from 'components/recordInformation/center'
import detail from 'components/recordInformation/detail'
import table from 'components/recordInformation/table'

export default {
  data() {
    return {
      items: [],
      name: '田阳县农业大脑——主体备案信息',
      positionTimes: 0
    }
  },
  mounted() {
    this.changeSwiper()
  },
  methods: {
    changeSwiper: function () {
      const that = this
      setTimeout(function () {
        that.positionTimes++
        that.changeSwiper()
      }, 3000)
    }
  },
  components: {
    'v-bar': bar,
    'v-header': header,
    'v-line': line,
    'v-center': center,
    'v-detail': detail,
    'v-table': table
  }
}

</script>

<style lang="stylus" scoped>
.item {
  margin-bottom: 15px;
}

.dashboard {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../static/img/common/bg.png');
  background-size: 100% 100%;
}

.container {
  display: flex;
  height: 100%;
  padding: 0 15px;

  .center {
    width: 1350px;
    margin: 30px auto;
  }

  .left, .right {
    width: 450px;
    margin-top: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6c22fe1a